import { getControlSizes } from './controlConfig';

/**
 * Create fix button image with dynamic count and size
 * @param {number} count - Number of errors
 * @returns {HTMLImageElement} Button image
 */
export function createFixSpellingImage(count) {
  const img = document.createElement('img');
  const label = count > 1 ? `Correggi (${count})` : 'Correggi';

  // Get current control sizes
  const { sizeX, sizeY } = getControlSizes();

  // Calculate font size proportionally to button size
  // Base font size is 28 for a 160x56 button
  const baseFontSize = count > 1 ? 24 : 28;
  const fontSize = Math.round((baseFontSize * sizeY) / 56);

  // Calculate corner radius proportionally
  const cornerRadius = Math.round((8 * sizeY) / 56);

  // Center text position
  const centerX = sizeX / 2;
  const centerY = sizeY / 2 + fontSize / 3; // Adjust for text baseline

  img.src =
    'data:image/svg+xml;base64,' +
    btoa(`
<svg width="${sizeX}" height="${sizeY}" xmlns="http://www.w3.org/2000/svg">
  <rect width="${sizeX}" height="${sizeY}" rx="${cornerRadius}" fill="#ff0000" opacity="0.9"/>
  <text x="${centerX}" y="${centerY}" font-family="Arial, sans-serif" font-size="${fontSize}" font-weight="bold" fill="white" text-anchor="middle">${label}</text>
</svg>
`);

  return img;
}
